import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";

import { Tooltip } from "@revvsales/components";
import { DateSelect } from "../../commonComponents";

class CreateDocFormFields extends Component {
  state = {};

  render() {
    return (
      <div>
        <span className="revvform-label">
          Turn around date
          <span className="requiredwitherr-input">*</span>
          <Tooltip
            placement="top"
            align={{
              offset: [0, 4],
            }}
            overlay="The date by when you need the document to be sent to the customer.">
            <span className="whats-this">
              <FontAwesomeIcon icon={["far", "question-circle"]} />
            </span>
          </Tooltip>
        </span>
        <div className="createdocformfields-datefield-wrapper">
          <DateSelect
            passDefaultDate
            selectedDate={this.props.turnAroundDate}
            returnValue={value => this.props.setTurnAroundDate(value)}
            placeholder="MM/DD/YYYY"
            minDate={moment().format()}
            className="create-doc-form-date"
          />
        </div>
      </div>
    );
  }
}

export default CreateDocFormFields;



// WEBPACK FOOTER //
// ./src/components/CreateDocPopup/CreateDocFormFields.js